import { render, staticRenderFns } from "./index-swiper.vue?vue&type=template&id=f59d258a"
import script from "./index-swiper.vue?vue&type=script&lang=js"
export * from "./index-swiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports